<template>
    <validation-provider :mode="mode" :vid="vid" :name="name" :rules="rules" v-slot="{ errors,validate }">
        <label style="direction: rtl" v-if="label!==''">{{ label }}<span v-if="isRequired"
                                                             class="text-danger ml-2">*</span></label>
        <slot v-bind:errors="errors" v-bind:validate="validate"></slot>
        <div class="invalid-feedback d-block">
            <span>{{ errors[0] }}</span>
        </div>
    </validation-provider>
</template>

<script>
export default {
    name: "ValidationItem",
    props: {
        name: {
            type: String,
            default: ''
        },
        rules: {
            type: [String, Array, Object],
            default: ''
        },
        vid: {
            type: String,
            default: ''
        },
        mode: {
            type: String,
            default: 'lazy'
        },
        label: {
            type: String,
            default: ''
        },
        hint:{
            type:String,
            default:''
        }
    },
    computed: {
        isRequired() {
            if (typeof this.rules === 'string') {
                return this.rules.includes('required')
            }
            return 'required' in this.rules
        },
    },
}
</script>

<style scoped>

</style>
